<template>
  <div class="settings-block landing-protection">
    <div class="settings-block__title">
      <div class="settings-block__title-text">
        {{ t('Landing Page Protection') }}
      </div>
    </div>

    <div class="lead mb-10">
      <span
        v-html="
          t(
            'You can protect your landing pages from direct visits.<br>Protection is based on calculating time difference between forwarding a user to landing page and time of actual visit to landing page.',
          )
        "
      ></span
      >&nbsp;<span
        v-html="
          t('Read more in our {0}.', [
            `<a href='https://docs.bemob.com/${i18n.global.locale.value}/landing-page-security' target='_blank' rel='noopener noreferrer'>${t('guide')}</a>`,
          ])
        "
      ></span>
    </div>

    <div class="landing-secret-key">
      <ui-copy-input
        :value="secretKey"
        class="mb-12"
        :label="t('Landing Secret Key')"
        plan-limits="landingPageProtection"
      />
    </div>

    <p class="mb-10">
      {{ t('You can see PHP example of signature verification here:') }}
      <br />
      <a
        class="example-link"
        href="https://gist.github.com/bemobtrk/c49cf4e45bd64c543a79fd2147f04c32"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://gist.github.com/bemobtrk/c49cf4e45bd64c543a79fd2147f04c32
      </a>
    </p>

    <p class="mb-10">
      {{ t('You can see Node.js example of signature verification here:') }}
      <br />
      <a
        class="example-link"
        href="https://gist.github.com/bemobtrk/ed5e638cfe3f3ea8f212fd1a1c473cb8"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://gist.github.com/bemobtrk/ed5e638cfe3f3ea8f212fd1a1c473cb8
      </a>
    </p>

    <p class="mb-10">
      {{ t('You can see JavaScript example of signature verification here:') }}
      <br />
      <a
        class="example-link"
        href="https://gist.github.com/bemobtrk/1e36fdd2334888a232e46e6bb71e2c8d"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://gist.github.com/bemobtrk/1e36fdd2334888a232e46e6bb71e2c8d
      </a>
    </p>
  </div>
</template>

<script setup lang="ts">
import i18n from '@/i18n';
import { useI18n } from '@/composables';

defineProps<{
  secretKey?: string;
}>();

const { t } = useI18n();
</script>

<style lang="scss" scoped>
.landing-protection {
  .example-link {
    max-width: 100%;
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  :deep(.v-input) {
    margin-top: 12px !important;
  }

  :deep(.v-input .v-label) {
    color: var(--color-graphite) !important;
    font-size: 16px !important;
    line-height: 1 !important;
  }

  .landing-secret-key {
    :deep(.copy-input) {
      margin-top: 0 !important;
    }
  }
}
</style>
